import { AuthErrorCode, LoginErrorCode } from '../../../constants/auth';
import { HttpStatus } from '../../common/types';

// User Types
/**
 * guest: new user
 * customer: customer
 * subscriber: customer with Marketing Subscription
 */
export type UserType = 'guest' | 'customer' | 'subscriber';

export type UserInfo = {
  id: number;
  email: string;
  displayName: string;
  otpVerified: boolean;
};

export type RegisteredUserInfo = {
  id: number;
  email: string;
  displayName: string;
};

// OTP Generate
export type GenerateOtpRequest = {
  phone: string;
};

export type GenerateOtpData = {
  otpId: string;
  expiresAt: string;
  deliveryMethod: string;
};

export type GenerateOtpResponse = {
  success: boolean;
  message: string;
  data?: GenerateOtpData;
};

// OTP Verify
export type VerifyOtpRequest = {
  phone: string;
  otp: string;
};

export type OtpVerificationUser = {
  userType: UserType;
  userId?: number;
  otpVerified?: boolean;
  candidateEmails?: string[];
};

export type OtpVerificationInfo = {
  user: OtpVerificationUser;
  verifiedAt: string;
};

export type VerifyOtpResponse = {
  success: boolean;
  message: string;
  otpVerificationInfo?: OtpVerificationInfo;
};

// Email Verification
export type VerifyEmailRequest = {
  phone: string;
  otp: string;
  selectedEmail: string;
};

export type VerifyEmailData = {
  emailVerified: boolean;
  user?: RegisteredUserInfo;
  remainingAttempts?: number;
  verifiedAt?: string;
};

export type VerifyEmailResponse = {
  success: boolean;
  message: string;
  data: VerifyEmailData;
  errorCode?: AuthErrorCode;
};

// Register
export type RegisterRequest = {
  phone: string;
  otp: string;
  name: string;
  email: string;
};

export type RegisterResponse = {
  success: boolean;
  message: string;
  user?: RegisteredUserInfo;
  errorCode?: AuthErrorCode;
};

// Password Login
export type LoginRequest = {
  username: string;
  password: string;
  remember?: boolean;
};

export type LoginErrorResponse = {
  code: LoginErrorCode;
  message: string;
};

export type LoginResponse = {
  success: boolean;
  user?: UserInfo;
  error?: LoginErrorResponse;
};

// API Error Response
export type ApiErrorResponse = {
  statusCode: HttpStatus;
  errorCode: AuthErrorCode;
  message: string;
};

// Rate Limit Error Response
export type RateLimitErrorResponse = ApiErrorResponse & {
  retryAfter: number;
};
